export const getGoogleMaps = () => {
    if (window.google && window.google.maps) {
        return window.google.maps;
    } else {
        return null;
    }
};
